import { APIService } from '@app/_services/api.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { API_PATH } from '@app/app.constants';

@Injectable()
export class TournamentsService {
    constructor(private api: APIService) {}

    getClassTournaments(classTitle: string): Observable<any> {
        const url = `${API_PATH.tournaments.class_tournaments}/${classTitle}/`;
        return this.api.get(url);
    }
}
